module.exports = __webpack_public_path__ + "img/42_53.52d1b878.png";